module.exports = __webpack_public_path__ + "static/media/shield-cross.a1f28055.svg";